export { default } from './ConfidenceSlider';
